/**
 * 接口域名的管理
 */
const base = {
//   system: '/api',//dev调试地址
system: 'http://192.168.8.6:8080',//服务器地址s
};

export default base;
